import { Link } from "react-router-dom";
import {useState,useEffect } from "react";
import $ from 'jquery';
import { toast } from 'react-toastify';
import apiClient from "../../http-common";
import useConfirm from "../../customHooks/useConfirm";
import {useFetchApi} from "../../customHooks/useFetch";
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { HTTPURL, REQUEST_OPTIONS, REQUEST_OPTIONS_NO_HEAD } from "../../constants/matcher";
import DataLoader from "../../Utils/DataLoader";


const AllAssignments = () => {
    const [reqData, setreqData] = useState({}); // <-- add state
    const { resData } = useFetchApi(reqData); // <-- pass location value to hook
    const {confirm} = useConfirm();
    const [assignmentList, setAssignmentList] = useStateWithCallbackLazy([]);
    const [showResults, setShowResults] = useStateWithCallbackLazy(false);

    const showConfirm = async (id) => {
        const isConfirmed = await confirm('Do you confirm your choice?');

        if (isConfirmed) {
            console.log('Confirmed!')
            deleteAssignment(id);
        } else {
            console.log('Declined.')
        }
    }

    const deleteAssignment = (requestData) =>
    {
        requestData = {
            'link' : 'admin/destroy-assignment/'+requestData,
            'token' : 'required',
        };
        setreqData(requestData);
    }

    useEffect( () =>
    {
        getAllAssignment();

        if(Object.keys(resData).length !== 0){
            if(resData.status===true){
                toast.success(resData.message)
            }else{
               toast.error(resData.message)
            }
        }
    }, [resData]);

    // get all assignments
    async function getAllAssignment()
    {
        try{
            const res = await  apiClient.get('/admin/all-assignment');
            setAssignmentList(res.data.data,() => 
            {
                setShowResults(true, () =>
                {
                    $('#datatablesSimple').DataTable();
                });
            })
        } catch(err) {
            console.log(err);
        }
    }
           
    return (
        <main>
            <div className="container-fluid px-4">
                <h1 className="mt-4">Assignments</h1>
                <ol className="breadcrumb mb-4">
                    <Link to="/secure/dashboard" className="breadcrumb-item">Dashboard</Link>
                    <li className="breadcrumb-item active">Assignments</li>  
                </ol>

                <div className="card mb-4">
                    <div className="card-header">
                        <i className="fas fa-table me-1"></i>
                        Assignments List
                        <div className="text-end">
                        <Link to="./add-assignment" className="breadcrumb-item">Add Assignment</Link>
                    </div>
                    </div>
                    <div className="card-body">
                    { 
                    showResults ?
                        <table id="datatablesSimple">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Title</th>
                                    <th>Created At</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {
                                assignmentList && assignmentList.map((assignment,index) => 
                                {
                                    return (
                                        <tr key={index}>  
                                            <td>
                                                {assignment.id}
                                            </td>
                                            <td>{assignment.lesson_name}</td>  
                                            <td>{assignment.created_at}</td>
                                            <td>
                                                <ul className="list-inline m-0">  
                                                    {/* <li className="list-inline-item">
                                                        <button className="btn btn-info btn-sm rounded-0" type="button" data-toggle="tooltip" data-placement="top" title="View Assignment">
                                                            <Link to={"./view-assignment/"+assignment.id} className="dropdown-item"><i className="fa fa-eye" aria-hidden="true"></i></Link>
                                                        </button>  
                                                    </li> */}
                                                    <li className="list-inline-item">
                                                        <button className="btn btn-primary btn-sm rounded-0" type="button" data-toggle="tooltip" data-placement="top" title="Edit Assignment">
                                                            <Link to={"./edit-assignment/"+assignment.id} className="dropdown-item"><i className='fas fa-edit'></i></Link>
                                                        </button>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <button className="btn btn-danger btn-sm rounded-0" type="button" data-toggle="tooltip" data-placement="top" title="Destroy Assignment" onClick={() => showConfirm(assignment.id)}>
                                                            <i className="fa fa-trash"></i>
                                                        </button>
                                                    </li>
                                                    <li className="list-inline-item">
                                                        <button className="btn btn-info btn-sm rounded-0" type="button" data-toggle="tooltip" data-placement="top" title="View Assignment">
                                                            <Link to={"./view-upload-assignments/"+assignment.id} className="dropdown-item"><i className='fa-solid fa-eye'></i></Link>
                                                        </button>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                        : <DataLoader/> }
                    </div>
                </div>
            </div>
        </main>
    )
};

export default AllAssignments;